import React from 'react';
import { Globe } from 'lucide-react';
import type { Language, Theme } from '../types';
import { languageNames } from '../utils/translations';
import { getIconColor, getFocusRingColor } from '../utils/themeUtils';

interface LanguageSelectorProps {
  currentLanguage: Language;
  onLanguageChange: (language: Language) => void;
  isDark: boolean;
  theme: Theme;
}

export function LanguageSelector({ currentLanguage, onLanguageChange, isDark, theme }: LanguageSelectorProps) {
  return (
    <div className="relative">
      <div className="flex items-center gap-2">
        <Globe className="w-4 h-4" style={getIconColor(theme)} />
        <select
          value={currentLanguage}
          onChange={(e) => onLanguageChange(e.target.value as Language)}
          className={`px-3 py-1 rounded-lg border text-sm ${
            isDark 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
          } focus:outline-none focus:ring-2`}
          style={getFocusRingColor(theme)}
        >
          {Object.entries(languageNames).map(([code, name]) => (
            <option key={code} value={code}>
              {name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}